export default "__VITE_ASSET__GBEAh4VO__"